import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleHero from "./components/ArticleHero";
import ArticleContent from "./components/ArticleContent";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuyspreadsheet.art";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": "Kompletny Przewodnik po Kakobuy Spreadsheet — Jak Znaleźć Najlepsze Produkty",
  "description": "Kompletny przewodnik po Kakobuy Spreadsheet. Dowiedz się czym jest arkusz Kakobuy, jak z niego korzystać i jak znaleźć najlepsze produkty.",
  "author": {
    "@type": "Organization",
    "name": "Kakobuy Sheet"
  },
  "dateModified": "2026-07-07",
  "datePublished": "2026-07-07",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": `${siteUrl}/guides/complete-kakobuy-spreadsheet-guide`
  },
  "publisher": {
    "@type": "Organization",
    "name": "Kakobuy Sheet",
    "url": siteUrl,
    "logo": {
      "@type": "ImageObject",
      "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png"
    }
  }
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Czy kakobuy spreadsheet jest darmowy?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Tak, dostęp do naszego arkusza Kakobuy jest całkowicie bezpłatny. Nie pobieramy żadnych opłat za przeglądanie produktów ani za przekierowania do sprzedawców."
      }
    },
    {
      "@type": "Question",
      "name": "Jak często aktualizowany jest arkusz Kakobuy?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Nasz Kakobuy spreadsheet jest aktualizowany codziennie. Regularnie dodajemy nowe produkty i usuwamy te, które utraciły na jakości bądź dostępności."
      }
    },
    {
      "@type": "Question",
      "name": "Czy mogę ufać produktom w arkuszu Kakobuy?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutnie. Każdy produkt w arkuszu Kakobuy przechodzi dokładną weryfikację. Publikujemy wyłącznie sprawdzone oferty od zaufanych sprzedawców, co potwierdzają setki zadowolonych użytkowników."
      }
    },
    {
      "@type": "Question",
      "name": "Jak mogę wrócić do strony głównej arkusza Kakobuy?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "W każdej chwili możesz kliknąć przycisk powrotu na górze strony lub skorzystać z linku Strona Główna w menu nawigacyjnym, aby wrócić do pełnej listy kategorii i produktów."
      }
    }
  ]
};

export default function ArticlePage() {
  useEffect(() => {
    const articleScript = document.createElement("script");
    articleScript.type = "application/ld+json";
    articleScript.textContent = JSON.stringify(structuredData);
    document.head.appendChild(articleScript);

    const faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.textContent = JSON.stringify(faqSchema);
    document.head.appendChild(faqScript);

    return () => {
      if (articleScript.parentNode) {
        articleScript.parentNode.removeChild(articleScript);
      }
      if (faqScript.parentNode) {
        faqScript.parentNode.removeChild(faqScript);
      }
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleContent />
      </main>
      <Footer />
    </>
  );
}